export default function toInteger(value) {
  return parseInt(`${value}`, 10);
}
